import React from 'react';
import { Box, Typography } from '@mui/material';
import { LoadingButton } from '@mui/lab';
import { useSnackbar } from 'notistack';
import { commonAPI } from '../../../api/common';
import { styles } from './styles';

const UpdateIntegration = () => {
    const { enqueueSnackbar } = useSnackbar();
    const [loadIntegrationConfiguration, { isLoading }] = commonAPI.useLoadIntegrationConfigurationMutation();

    const handleClick = async () => {
        try {
            const response = await loadIntegrationConfiguration().unwrap();
            if (!response) return;
            if (response?.status === 'ERROR') throw new Error(response?.message);
            enqueueSnackbar('Integration Updated Succesfuly', {
                variant: 'success',
            });
        } catch (error) {
            if (error?.statusCode === 400) enqueueSnackbar(error?.data?.message, { variant: 'error' });
            else enqueueSnackbar(error?.message || 'Something went wrong!', { variant: 'error' });
        }
    };
    return (
        <Box>
            <Box sx={styles.contentHeaderWrapper}>
                <Typography variant="h4">Refresh Integration</Typography>
                <LoadingButton
                    loading={isLoading}
                    color="primary"
                    onClick={handleClick}
                    size="large"
                    variant="contained"
                    sx={{
                        ':hover': {
                            backgroundColor: 'secondary.main',
                        },
                    }}
                >
                    Refresh
                </LoadingButton>
            </Box>
        </Box>
    );
};

export default UpdateIntegration;
